import React, {Dispatch, SetStateAction} from "react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons"
import ReactTooltip from "react-tooltip"
import {isUndefined} from "lodash"

export default function ApplicationsDefaultBankSelector({
	defaultBankName,
	setDefaultBankName,
	bankNames,
	isDisabled,
}: {
	defaultBankName?: string
	setDefaultBankName: Dispatch<SetStateAction<string | undefined>>
	bankNames?: string[]
	isDisabled?: boolean
}) {
	return (
		<div className="field">
			<label className="label application-bank-name-label">
				Default Bank for New Applications{" "}
				<label className="tooltip-container has-text-weight-normal">
					<a data-tip="React-tooltip" data-for="fallback-bank-tooltip" data-event="click focus">
						<FontAwesomeIcon icon={faInfoCircle} color="#545558" />
						<ReactTooltip
							id="fallback-bank-tooltip"
							place="right"
							className="tooltip-info"
							globalEventOff="click"
							border={true}
							borderColor="#C4C4C4"
							backgroundColor="#F5F5F5"
							textColor="black"
							data-html={true}
						>
							The Default Bank for New Applications will be used to assign each newly created application to the bank
							where the applicant is applying for an account.
						</ReactTooltip>
					</a>
				</label>
			</label>
			<div className="field-body">
				<div className="select">
					<select
						required={!isUndefined(bankNames)}
						value={defaultBankName}
						onChange={(e) => setDefaultBankName(e.target.value)}
						disabled={isDisabled ?? false}
						className="applications-bank-name-selection"
					>
						{isUndefined(defaultBankName) ? <option key="default" defaultValue="" /> : null}
						{bankNames?.map((name) => (
							<option key={name} value={name}>
								{name}
							</option>
						))}
					</select>{" "}
				</div>
			</div>
		</div>
	)
}
